<template>
  <div class="content">
    <Header></Header>
    <Banner :bannerImg="$store.getters.getUrl('ob_banner')"></Banner>
    <LogoNameImg :logoNameImg="$store.getters.getUrl('ob_logoNameImg')"></LogoNameImg>
    <Downbtn></Downbtn>
    <Xianlu></Xianlu>
    <KindList></KindList>
    <Serves></Serves>
    <Bottom :bottomImg="$store.getters.getUrl('ob_bottomImg')"></Bottom>
    <a :href="kefu_address" class="btn" target="_blank">
      <img :src="$store.getters.getUrl('kf')" alt=""  class="kf" />
    </a>
  </div>
</template>

<script>
import Banner from "@page/landing/components/banner.vue";
import LogoNameImg from "@page/landing/components/logoNameImg.vue";
import Bottom from "@page/landing/template/ob/components/bottom.vue";


import Header from "@page/landing/template/ob/components/header.vue";
import Downbtn from "@page/landing/template/ob/components/downbtn.vue";
import Xianlu from "@page/landing/template/ob/components/xianlu.vue";
import KindList from "@page/landing/template/ob/components/kindList.vue";
import Serves from "@page/landing/template/ob/components/serves.vue";
import { get } from "lodash-es";

export default {
  components: {
    Header,
    Banner,
    LogoNameImg,
    Downbtn,
    Xianlu,
    KindList,
    Serves,
    Bottom
  },
  computed: {
    kefu_address() {
      return get(this.$store.state, "webUrls.official_kefu_url", "");
    },
  }
};
</script>

<style lang="scss" scoped>
.content{
  background: url('../../../../assets/base64Img/ob.jpg') center center;
  background-size: 100% 100%;
  .kf{
    position: fixed;
    right: 0px;
    top: 78%;
    width:120px;
    z-index: 9999;
  }
}
</style>
